import React from 'react'
import AuthenticationForm from '../Authentication/AuthenticationForm'

export default function AuthenticationPage() {
    return (
        <AuthenticationForm />
    )
}
